export default {"src":"/_next/static/media/AJX.1d8b4aac.svg","height":18,"width":18};